import { useDrainsStore } from '../../../../hooks/useDrainsStore';

export const SelectedLocationTextContent = () => {
  const {
    data: { serviceLocationDetails, assetDetails },
  } = useDrainsStore();

  return (
    serviceLocationDetails.full_address && (
      <div className="text-bodyXl mt-4 flex flex-col gap-[1.25rem]">
        <p className="font-semibold text-black">{`Nearest address to the drain`}</p>
        <p className="font-normal text-black">
          {serviceLocationDetails.full_address}
        </p>
        <p className="font-semibold text-black">{`Drain`}</p>
        <p className="font-normal text-black">
          {assetDetails?.central_asset_id
            ? `Drain selected ${assetDetails?.central_asset_id}`
            : 'No drain selected'}
        </p>
      </div>
    )
  );
};
